export default function fileSizeString (val) {
  const totalSize = val;
  let data='';
  let ext='';
  let newSize =0;
  if(totalSize< 1024) {
    newSize = totalSize;
    ext='Bytes';
  }else if(totalSize> 1024 && totalSize < 1048576) {
    newSize = totalSize / 1024;
    ext='KB';
  }else if(totalSize > 1048576 && totalSize < 1073741824) {
    newSize = totalSize / 1048576;
    ext='MB';
  }else if(totalSize > 1073741824 && totalSize < 1099511627776) {
    newSize = totalSize / 1073741824;
    ext='GB';
  }else if(totalSize > 1099511627776) {
    newSize = totalSize / 1099511627776;
    ext='TB';
  }
  const rounded = Math.round((newSize+ 0.00001) * 100) / 100;
  data=`${rounded} ${ext}`;
  return data;
}